import React from 'react';
import ContentLoader from 'react-content-loader';

interface SearchPlaceholderListProps {
  length: number;
}

export const SearchPlaceholderList = ({ length }: SearchPlaceholderListProps) => {
  return (
    <ul>
      {[...Array(length)].map((_, i) => (
        <ContentLoader
          key={i}
          speed={1}
          width={250}
          height={9}
          viewBox="0 0 250 9"
          backgroundColor="#ececec"
          foregroundColor="#cccccc"
        >
          <rect x="0" y="2" rx="3" ry="3" width="250" height="5" />
        </ContentLoader>
      ))}
    </ul>
  );
};
